import BaseService from '../../base/base_service';

export default class CompanySelectorService extends BaseService {
    static CLASS = 'CompanySelectorService';

    init(params) {
        super.init(params);
    }

    async getCompany(companyName) {
        let regulation = this.serviceFactory.regulationService().getRegulation();

        const dependenciesFactory = (await import('./dependencies/company_selector_service_dependencies_factory')).default.create({
            getServicesFactoryCallback: () => this.serviceFactory
        });
        let company = dependenciesFactory.companyImplementationReader().getCompany(companyName);
        let specificRegulatedCompany = dependenciesFactory.regulatedCompanySpecificImplementationReader().tryApplyRegulation(regulation, company);
        if(specificRegulatedCompany) {
            return specificRegulatedCompany;
        }

        return dependenciesFactory.regulatedCompanyDefaultImplementationReader().applyRegulation(regulation, company);
    }
}